import { useEffect, useState } from "react";
import { api, eur } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { InviaClienteDialog } from "@/components/InviaClienteDialog";
import { AlertTriangle, Send } from "lucide-react";

// Proposte inviate con il vecchio link «Accetta la proposta» non funzionante: un click apre l'anteprima di reinvio.
export const ReinvioProposte = () => {
  const [items, setItems] = useState([]);
  const [qid, setQid] = useState(null);
  const load = () => api.get("/quotes-da-reinviare").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-4" data-testid="reinvio-proposte">
      <div className="flex items-start gap-2 text-amber-900">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" />
        <div>
          <div className="font-semibold">{items.length} {items.length === 1 ? "proposta da reinviare" : "proposte da reinviare"}</div>
          <p className="text-xs">In queste email il pulsante «Accetta la proposta» non funzionava. Reinviale: il nuovo link è corretto.</p>
        </div>
      </div>
      <ul className="mt-3 divide-y divide-amber-200">
        {items.map((q) => (
          <li key={q.id} className="flex flex-wrap items-center justify-between gap-2 py-2 text-sm" data-testid={`reinvio-${q.id}`}>
            <span className="text-forest"><b>{q.codice}</b> · {q.cliente}{q.partner ? ` · ${q.partner}` : ""} · {eur(q.premio_finale)} <span className="text-xs text-muted-foreground">inviata il {new Date(q.inviato_cliente_at).toLocaleDateString("it-IT")}</span></span>
            <Button size="sm" onClick={() => setQid(q.id)} className="h-8 gap-1.5 bg-terracotta hover:bg-terracotta-hover" data-testid={`reinvio-btn-${q.id}`}><Send className="h-3.5 w-3.5" />Reinvia</Button>
          </li>
        ))}
      </ul>
      {qid && <InviaClienteDialog qid={qid} open={!!qid} onOpenChange={(o) => !o && setQid(null)} onSent={load} />}
    </div>
  );
};
